import 'core-js';
import Vue from 'vue';
import Vuetify from 'vuetify';
import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate';
import axios from 'axios';
// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';

Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(Vuetify, {
    theme: {
        primary: '#00796b', //teal darken-2
        secondary: '#673ab7', //deep-purple base
        accent: '#1976D2', //blue darken-2
        error: '#FF5252', //red base
        info: '#3F51B5', //indigo
        success: '#4CAF50', //green base
        warning: '#FF8F00', //amber base
        activated: '#00796b', //teal darken-2
        disabled: '#757575', //grey darken-1
    },
});

window.Vue = Vue;
window.axios = axios;
window.axios.defaults.headers.common = {'X-Requested-With': 'XMLHttpRequest'};

window.debounce = function (fn, delay) {
    let timeoutID = null;
    return function () {
        clearTimeout(timeoutID);
        let args = arguments;
        let that = this;
        timeoutID = setTimeout(function () {
            fn.apply(that, args);
        }, delay);
    };
};

window.detectOS = function () {
    let userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        // windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;

    if (macosPlatforms.indexOf(platform) !== -1) os = 'Mac';
    else if (iosPlatforms.indexOf(platform) !== -1) os = 'iOS';
    else if (/Android/.test(userAgent)) os = 'Android';
    else if (!os && /Linux/.test(platform)) os = 'Linux';
    else os = 'Windows';

    return os;
};

/**
 * Unauthenticated Error Handling
 */
axios.interceptors.response.use(null, function (error) {
    if (error.response.status === 401) {
        return window.location = '/';
    } else if (error.response.status === 419) {
        return location.reload(true);
    }
    return Promise.reject(error);
});

/**
 * Sentry Vue Error Tracking
 */
// if (['development', 'production'].includes(process.env.MIX_APP_ENV)) {
//     Sentry.init({
//         dsn: 'https://2649f1077947409e921ec6c9bf6e2c5c@sentry.io/1361209',
//         environment: process.env.MIX_APP_ENV,
//         integrations: [
//             new Integrations.Vue({
//                 Vue,
//                 attachProps: true,
//             }),
//         ],
//     });
// }
